import { useState } from "react";
import { X, Phone } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { InternationalPhoneInput } from "@/components/ui/international-phone-input";
import { toast } from "sonner";
import { logger } from '@/lib/logger';

interface PhoneLoginDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const PhoneLoginDialog = ({ open, onOpenChange }: PhoneLoginDialogProps) => {
  const [telephone, setTelephone] = useState<string | undefined>("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!telephone?.trim()) {
      toast.error("Veuillez saisir votre numéro de téléphone");
      return;
    }

    setIsLoading(true);
    
    try {
      // Rediriger vers la page d'authentification avec téléphone pré-rempli
      logger.log("Recherche du téléphone:", telephone);
      
      // Fermer la modal et rediriger vers l'auth avec le téléphone
      handleClose();
      
      // Redirection vers la page d'auth
      window.location.href = `/auth?origin=nav&phone=${encodeURIComponent(telephone)}`;
      
    } catch (error) {
      logger.error("Erreur lors de la vérification:", error);
      toast.error("Une erreur est survenue");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setTelephone(undefined);
    setIsLoading(false);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-semibold">
            Connexion
          </DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="telephone" className="text-sm font-medium">
              Numéro de téléphone
            </Label>
            <InternationalPhoneInput
              value={telephone}
              onChange={setTelephone}
              placeholder="Votre numéro de téléphone"
              disabled={isLoading}
              className="w-full"
            />
          </div>
          
          <Button
            type="submit"
            className="w-full"
            disabled={isLoading || !telephone?.trim()}
          >
            {isLoading ? "Vérification..." : "Continuer"}
          </Button>
        </form>
        
        <div className="text-center text-sm text-muted-foreground">
          <p>
            Nous vérifierons si un compte existe avec ce numéro
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};